import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { logout } from '../actions/authActions';

export default function Header() {
  const { user } = useSelector(s => s.auth);
  const dispatch = useDispatch();
  const isStaff = user && (user.role === 'admin' || user.role === 'manager' || user.role === 'sales');
  return (
    <header className="app-header">
      <Link to="/" className="logo"><img src="/logo.svg" alt="HR without Borders" /></Link>
      <nav className="nav">
        <NavLink to="/inventory">Inventory</NavLink>
        <NavLink to="/questions">Q&amp;A</NavLink>
        <NavLink to="/articles">Articles</NavLink>
        {user && <NavLink to="/dashboard">Dashboard</NavLink>}
        {isStaff && <NavLink to="/admin">Admin</NavLink>}
        <NavLink to="/docs">Docs</NavLink>
      </nav>
      <div className="auth-cluster">
        {user ? (
          <>
            <Link to="/profile" className="hello">Hi, {user.name || user.email}</Link>
            <button className="btn-ghost" onClick={() => dispatch(logout())}>Sign out</button>
          </>
        ) : (
          <>
            <Link to="/login" className="btn-ghost">Sign in</Link>
            <Link to="/signup" className="btn-primary">Sign up</Link>
          </>
        )}
      </div>
    </header>
  );
}
